import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Link } from 'gatsby';
import { Alert } from '@printdeal/ui-library';

import { SanitizedLineItem } from '../../../../../../types/order/Order';

interface ListInvalidProductsProps {
  invalidLineItems: SanitizedLineItem[];
}

const ListInvalidProducts = ({ invalidLineItems }: ListInvalidProductsProps) => {
  const intl = useIntl();

  if (invalidLineItems.length === 0) {
    return null;
  }

  return (
    <Alert className="pd-my-3" variant="info">
      <ul className="pd-list-disc">
        {invalidLineItems.map((lineItem) => (
          <li>
            <FormattedMessage
              id="account.order.reorder.body.invalid.product"
              defaultMessage="The product: {lineItemNumber} - {localizedProductName}, is not valid anymore. {newLine} You can configure the product again with this {link}."
              values={{
                lineItemNumber: lineItem.custom.fields.lineItemNumber,
                localizedProductName: lineItem.custom.fields.localizedProductName?.[intl.locale]
                  || lineItem.custom.fields.merchandisingProductName,
                newLine: <br />,
                link: <Link to={lineItem.custom.fields.merchProductURL}><FormattedMessage id="account.order.reorder.body.invalid.product.url" defaultMessage="link to product" /></Link>,
              }}
            />
          </li>
        ))}
      </ul>
    </Alert>
  );
};

export default ListInvalidProducts;
